import React, {useMemo} from 'react';
import {NumericFormat} from "react-number-format";
import {DateCalendarForm2} from "components";
import {calculateTotals} from "utils";

export const CalendarAndTotals = ({controlDate, list}) => {
    const {openCount, incompleteCount, completedCount,tripsCount, total} =  useMemo(() => calculateTotals(list), [JSON.stringify(list)]);

    return (
        <div className='dispatch-board-main-info-wrapper'>
            <DateCalendarForm2 control={controlDate} name='serviceDate'/>

            <div className='dispatch-board-main-info-block'>
                <div
                    className='dispatch-board-main-info-item'
                    style={{background: '#F3F4F6'}}
                >
                    <p
                        className='dispatch-board-main-info-item_text'
                        style={{fontWeight: 400}}
                    >
                        Open:
                    </p>

                    <p className='dispatch-board-main-info-item_text'>
                        {/*{legTotals?.open ? legTotals?.open : '--'}*/}
                        {openCount || '--'}
                    </p>
                </div>

                <div
                    className='dispatch-board-main-info-item'
                    style={{background: '#EEF2FF'}}
                >
                    <p
                        className='dispatch-board-main-info-item_text'
                        style={{fontWeight: 400}}
                    >
                        Incomplete:
                    </p>

                    <p className='dispatch-board-main-info-item_text'>
                        {/*{legTotals?.inComplete ? legTotals?.inComplete : '--'}*/}
                        {incompleteCount || '--'}
                    </p>
                </div>

                <div
                    className='dispatch-board-main-info-item'
                    style={{background: '#ECFDF5'}}
                >
                    <p
                        className='dispatch-board-main-info-item_text'
                        style={{fontWeight: 400}}
                    >
                        Completed:
                    </p>

                    <p className='dispatch-board-main-info-item_text'>
                        {completedCount || '--'}
                    </p>
                </div>

                <div
                    className='dispatch-board-main-info-item'
                    style={{background: 'rgba(136, 195, 225, 0.42)'}}
                >
                    <p className='dispatch-board-main-info-item_text' style={{fontWeight: 400}}>
                        Trips:
                    </p>
                    <p className='dispatch-board-main-info-item_text'>
                        {tripsCount || '--'}
                    </p>
                    <div className='board-main-info-item-line'/>

                    {/*{legTotals?.total ?*/}
                    {/*    <NumericFormat*/}
                    {/*        className='dispatch-board-main-info-item_text'*/}
                    {/*        value={legTotals?.total}*/}
                    {/*        decimalScale*/}
                    {/*        thousandSeparator={true}*/}
                    {/*        displayType={"text"}*/}
                    {/*        allowNegative={false}*/}
                    {/*        prefix={"$"}*/}
                    {/*    />*/}
                    {/*    :*/}
                    {/*    '--'*/}
                    {/*}  */}

                    {total ?
                        <NumericFormat
                            className='dispatch-board-main-info-item_text'
                            value={total}
                            decimalScale
                            thousandSeparator={true}
                            displayType={"text"}
                            allowNegative={false}
                            prefix={"$"}
                        />
                        :
                        '--'
                    }
                </div>
            </div>
        </div>
    );
};

